import React, {useEffect, useState} from 'react';
import {
  View,
  Text,
  TouchableOpacity,
  ScrollView,
  StyleSheet
} from 'react-native';
import {useSelector} from 'react-redux';
import OrderItem from '../../commons/orderItem';
import OrderItemImage from '../../commons/orderItemImage';
import { selectFocusedOrder } from '../../actions/ScanToCartScanningActions';
import { filterItemsByOrderId, filterItemsByOrderItemIds, getOrderItemIdsByToteId, getOrderItemItIds, getScannedPieceCount } from './utils/scanningUtils';
import useToteStatus from './useToteStatus';

const ScannedItemsList = ({onItemPress = () => {}}) => {
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const focusedOrderId = useSelector(selectFocusedOrder)?.id ?? null;
  const allScannedItems = useSelector(
    state => state.scanToCart.scannedItems
  );
  const scannedItems = filterItemsByOrderId(allScannedItems, focusedOrderId);
  const { nextPickOrderId } = useToteStatus();

  useEffect(() => {
    setItemsPerPage(10);
  }, [focusedOrderId]);

  const totalScannedCount = getScannedPieceCount(scannedItems);

  const isPicked = useSelector(
    state => state.scanToCart.activeCart.isPicked
  );
  const isScanComplete = useSelector(
    state => state.scanToCartScanning.cartScanComplete
  );

  const activeTote =  useSelector(state => state.scanToCartScanning.activeTote);
  const toteAssignments =  useSelector(state => state.scanToCart.toteAssignments)
  const getScannedItems = () => {
    if(focusedOrderId !== null) {
      return scannedItems;
    }
    if(activeTote && isScanComplete) {
      const orderIds = getOrderItemIdsByToteId(toteAssignments,activeTote?.cart_tote_id);
      const filteredItems = filterItemsByOrderItemIds(scannedItems, orderIds);
      return filteredItems;
    }
    if(nextPickOrderId && isPicked) {
      const orderItemIds = getOrderItemItIds(toteAssignments, nextPickOrderId);
      const filteredItems = filterItemsByOrderItemIds(scannedItems, orderItemIds);
      return filteredItems;
    }
    return scannedItems;
  }
  const items = getScannedItems();

  const renderScannedItem = (item, index) => (
    <View
      key={`scanned-${item.product_id || item.id}-${index}`}
      style={styles.scannedItemWrapper}>
      <View style={styles.scannedItemContainer}>
        <OrderItem
          item={item}
          redirectToItemDetail={onItemPress}
          testID={'redirectToItem'}
        />
        <OrderItemImage
          item={item}
          shuffleTheItem={() => {}} // No shuffle for scanned items
          listType={'scanned'}
        />
      </View>
    </View>
  );

  const displayedItems = items.slice(0, itemsPerPage);
  const hasMoreItems = items.length > itemsPerPage;

  return (
    <View style={styles.container}>
      {/* Header */}
      <Text style={styles.headerTitle}>{totalScannedCount} Scanned Items</Text>

      {/* Items List */}
      <ScrollView
        style={styles.scrollContainer}
        showsVerticalScrollIndicator={false}>
        {displayedItems.length > 0 ? (
          displayedItems.map((item, index) => renderScannedItem(item, index))
        ) : (
          <View style={styles.emptyContainer}>
            <Text style={styles.emptyText}>
              {focusedOrderId === null ? 'No scanned items' : 'No scanned items for this order'}
            </Text>
          </View>
        )}

        {/* Show More Button */}
        {hasMoreItems && (
          <TouchableOpacity
            style={styles.showMoreButton}
            onPress={() => setItemsPerPage(prev => prev + 10)}>
            <Text style={styles.showMoreText}>Show More</Text>
          </TouchableOpacity>
        )}

        {/* Reset Button */}
        {itemsPerPage > 10 && (
          <TouchableOpacity
            style={styles.resetButton}
            onPress={() => setItemsPerPage(10)}>
            <Text style={styles.resetText}>Reset</Text>
          </TouchableOpacity>
        )}
      </ScrollView>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: 'transparent'
  },
  headerTitle: {
    color: '#fff',
    fontSize: 15,
    fontFamily: 'Poppins_600SemiBold',
    fontWeight: 'bold',
    backgroundColor: '#000',
    textAlign: 'center',
    paddingVertical: 10
  },
  scrollContainer: {
    flex: 1
  },

  // Wrapper styles to match original scanned items layout
  scannedItemWrapper: {
    marginBottom: 8
  },
  scannedItemContainer: {
    flexDirection: 'row',
    borderRadius: 30
  },

  // Action Buttons
  showMoreButton: {
    backgroundColor: '#41970f',
    padding: 12,
    borderRadius: 5,
    margin: 10,
    alignItems: 'center'
  },
  showMoreText: {
    color: '#fff',
    fontSize: 18,
    fontWeight: 'bold'
  },
  resetButton: {
    backgroundColor: '#f54400',
    padding: 12,
    borderRadius: 5,
    margin: 10,
    alignItems: 'center'
  },
  resetText: {
    color: '#fff',
    fontSize: 16,
    fontWeight: 'bold'
  },

  // Empty State
  emptyContainer: {
    padding: 20,
    alignItems: 'center'
  },
  emptyText: {
    color: '#fff',
    fontSize: 16
  }
});

export default ScannedItemsList;
